const extensionFor = (name) => String(name || "").trim().toLowerCase().split(".").pop() || "";

const SPREADSHEET_TYPES = new Set([
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "application/vnd.ms-excel.sheet.macroenabled.12",
  "text/csv",
  "application/csv",
]);

export const sourcePreviewKind = (record = {}) => {
  const contentType = String(record.contentType || record.type || "").trim().toLowerCase();
  const filename = record.originalFilename || record.name || "";
  const extension = extensionFor(filename);
  if (contentType.startsWith("image/") || ["png", "jpg", "jpeg", "webp", "gif"].includes(extension)) return "image";
  if (contentType === "application/pdf" || extension === "pdf") return "pdf";
  if (SPREADSHEET_TYPES.has(contentType) || ["xlsx", "xls", "csv"].includes(extension)) return "spreadsheet";
  return "metadata";
};

export const isLegacySpreadsheet = (record = {}) => extensionFor(record.originalFilename || record.name) === "xls";
